import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import { Card, CardBody, Col, Row } from "reactstrap"
import PropTypes from "prop-types"
import { getTotalSales, getTotalPurchaseCreatedWise } from "http/dashboard"
import NoDataChart from "pages/Dashboards/NoDataChart"
import moment from "moment";

const TotalSales = ({ userType, startDate, endDate }) => {
  const [dealsData, setDealsData] = useState([])
  const [showStatus, setShowStatus] = useState(true)
  const [type, setType] = useState('month');
  const [graphType, setGraphType] = useState('area');

  useEffect(() => {
    if (userType == 'dealer') {
      getTotalPurchaseCreatedWise({type})
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length>0) {
            setDealsData(responseFromApi.data)
          } else {
            setShowStatus(false)
            setDealsData([])
          }
        })
        .catch(error => { })
    } else {
      getTotalSales()
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length>0) {
            setDealsData(responseFromApi.data)
          } else {
            setShowStatus(false)
            setDealsData([])
          }
        })
        .catch(error => { })
    }
  }, [])

  useEffect(() => {
    if (userType == 'dealer' && startDate && endDate) {
      getTotalPurchaseCreatedWise({startDate,endDate,type})
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length>0) {
            setDealsData(responseFromApi.data)
            setShowStatus(true)
          } else {
            setShowStatus(false)
            setDealsData([])
          }
        })
        .catch(error => { })
    } else if (startDate && endDate) {
      getTotalSales({ startDate, endDate, type })
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length>0) {
            setDealsData(responseFromApi.data)
            setShowStatus(true)
          } else {
            setShowStatus(false)
            setDealsData([])
          }
        })
        .catch(error => { })
    }
  }, [startDate, endDate])

  const currencyShotern = amount => {
    if (amount && !isNaN(amount) && amount != undefined) {
      const formatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        notation: "compact",
        compactDisplay: "long",
      })
      return formatter.format(amount)
    } else return "0.00"
  }

  const formatDate = (dateString) => {
    if (type == 'quarter') {
      return dateString
    }
    if (dateString.length === 10) {
      return moment(dateString, "YYYY-MM-DD").format("MMM D, YYYY");
    }
    return moment(dateString).format("MMM-YYYY");
  };

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: graphType,
      height: 500,
    },
    plotOptions: graphType == 'bar' ? {
      bar: {
        horizontal: false,
        endingShape: "rounded",
        barHeight: "50%",
        columnWidth: "40%",
        borderRadius: 4,
        dataLabels: {
          position: "center",
        },
      },
    } : {},
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        return currencyShotern(val);
      },
    },
    colors: graphType == 'bar' ? [
      function getColorByDataPointIndex({ dataPointIndex }) {
        const colors = [
          "#EC7063",
          "#AF7AC5",
          "#3498DB",
          "#1ABC9C",
          "#F1C40F",
          "#E74C3C",
          "#8E44AD",
          "#2980B9",
          "#27AE60",
          "#F39C12",
          "#D35400",
          "#2C3E50",
        ];
        if (dataPointIndex >= 0 && dataPointIndex < colors.length) {
          return colors[dataPointIndex];
        }
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        return randomColor;
      }
    ] : ["#5499C7"],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    xaxis: {
      title: {
        text: "Month-Year",
      },
      style: {
        fontSize: "16.5px",
        color: "#333",
        background: "transparent",
        maxWidth: 300,
        overflow: "ellipsis",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      labels: {
        show: true,
        trim: true,
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
      },
      categories: dealsData.map(data => formatDate(data.monthYear)),
    },
    yaxis: {
      title: {
        text: "Amount",
      },
      labels: {
        formatter: val => {
          return currencyShotern(val)
        },
        style: {
          colors: "#333",
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    tooltip: {
      enabled: true,
      y: {
        enabled: true,
        formatter: (val) => {
          return currencyShotern(val);
        },
      }
    },
  }

  const series = [
    {
      name: "Amount",
      data: dealsData.map(data => parseInt(data.amount)),
    },
  ]

  const handleFilterChange = (e) => {
    setType(e.target.value);
    if (userType == 'dealer') {
      getTotalPurchaseCreatedWise({type: e.target.value})
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length > 0) {
            if (e.target.value == 'quarter') {
              let resultData = sortQuarterlyData(responseFromApi.data)
              setDealsData(resultData)
            } else {
              setDealsData(responseFromApi.data)
            }
          } else {
            setShowStatus(false)
            setDealsData([])
          }
        })
        .catch(error => { })
    } else {
      getTotalSales({ type: e.target.value, startDate, endDate })
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length > 0) {
            if (e.target.value == 'quarter') {
              let resultData = sortQuarterlyData(responseFromApi.data)
              setDealsData(resultData)
            } else {
              setDealsData(responseFromApi.data)
            }
          } else {
            setShowStatus(false)
            setDealsData([])
          }
        })
        .catch(error => { })
    }
  };

  const sortQuarterlyData = (data) => {
    const monthMap = {
      "Jan": 1,
      "Apr": 2,
      "Jul": 3,
      "Oct": 4
    };
    return data?.sort((a, b) => {
      const quarterA = a.monthYear.split(",")[0].split("-")[0].trim();
      const yearA = parseInt(a.monthYear.split(",")[1].trim());

      const quarterB = b.monthYear.split(",")[0].split("-")[0].trim();
      const yearB = parseInt(b.monthYear.split(",")[1].trim());

      if (yearA === yearB) {
        return monthMap[quarterB] - monthMap[quarterA];
      }

      return yearA - yearB;
    });
  };

  const handleToggle = tab => {
    setGraphType(tab)
  }

  return (
    <Card className="h-100">
      {showStatus ? <CardBody>
        <Row className='mb-2 custom-border'>
          <Col lg='5' sm='12' md='5'>
            <h4 className="card-title mb-2">
              {userType === "admin"
                ? "Total  Sales"
                : "Total Purchases"}
            </h4>
          </Col>
          <Col lg='5' sm='12' md='5' className="mb-2 custom-select-wrapper">
            <select
              className="form-select"
              id="filterOptions"
              value={type}
              onChange={handleFilterChange}
            >
              <option value="day">Day Wise</option>
              <option value="month"> Month wise</option>
              <option value="quarter">Quarter wise</option>
            </select>
          </Col>
          <Col lg='2' sm='12' md='2' className="mb-2 custom-select-wrapper">
            <div className="d-sm-flex justify-content-end">
              <div className="toggle-switch-container">
                <div className="toggle-switch" style={{ width: '100px', height: '36px' }}>
                  <label
                    className={`switch-label ${graphType === "area" ? "active" : ""
                      } mt-1`}
                    onClick={() => handleToggle("area")}
                    onKeyDown={event => {
                      if (event.key === "Enter") {
                        handleToggle("area")
                      }
                    }}
                  >
                    Line
                  </label>
                  <label
                    className={`switch-label ${graphType === "bar" ? "active" : ""
                      } mt-1`}
                    onClick={() => handleToggle("bar")}
                    onKeyDown={event => {
                      if (event.key === "Enter") {
                        handleToggle("bar")
                      }
                    }}
                  >
                    Bar
                  </label>
                  <div
                    className={`slider ${graphType === "bar" ? "slide-right" : ""
                      }`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div id="vertical-bar-chart-top-financiers">
          {dealsData.length > 0 ? (
            <ReactApexChart
              options={options}
              series={series}
              type={graphType}
              height={315}
            />
          ) : (
            <div
              style={{
                textAlign: "center",
                paddingTop: "20px",
                color: "#ccc",
                height: "270px",
                display: 'flex',
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h5> No data available</h5>
            </div>
          )}
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle={`No ${userType === "admin" ? "total sales" : "total purchases"} data is available at the moment`} />
      }
    </Card>
  )
}

TotalSales.propTypes = {
  userType: PropTypes.string.isRequired,
}

export default TotalSales
